import React, {Component} from 'react'
import './index.css'
import localization from "../../../config/localization"
import {homePathGenerator, parseRouting, setPageTitle} from "../../../api-client/core/authentication/utils";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import FavoritesContentCreation from "./FavoritesContentCreation";
import FavoritesContentCreator from "./FavoritesContentCreator";
import browserHistory from "../../../utils/browserHistory";

class Favorites extends Component {

  state = {
    search: "",
    searchType: window.location.pathname.includes("favoritos/creaciones") ? "creations" : "creators",
  }

  componentDidMount = () => {
    setPageTitle(localization.get('title.favorites'))
    document.getElementsByTagName("html")[0].scrollTop = 0;
  }

  FavoritesContentCreator = (props) => <FavoritesContentCreator  {...props}/>
  FavoritesContentCreation = (props) => <FavoritesContentCreation  {...props}/>

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (window.location.pathname.includes("favoritos/creaciones") && this.state.searchType === "creators") {
      this.setState({searchType: "creations"})
    }else if (window.location.pathname.includes("favoritos/creadores") && this.state.searchType === "creations") {
      this.setState({searchType: "creators"})
    }
  }

  render = () => {

    return (
      <div id="innerinner" style={{ marginBottom: '10px' }}>
        <div className={"favorites-category-type-selection"}>
          <div
            className={`${this.state.searchType === "creators" ? "favorites-category-type-selected" : "favorites-category-type-not-selected"}`}
            style={{
              width: "100%",
              borderBottomLeftRadius: 30,
              borderTopLeftRadius: 30,
              lineHeight: "36px"
            }}
            onClick={() => this.setState({searchType: "creators"}, () => browserHistory.push(homePathGenerator("favoritos/creadores")))}
          >
            <p className={"favorites-category-type"}>{localization.get("favorites.creators")}</p>
          </div>
          <div
            style={{
              width: "100%",
              borderBottomRightRadius: 30,
              borderTopRightRadius: 30,
              lineHeight: "36px"
            }}
            className={`${this.state.searchType === "creations" ? "favorites-category-type-selected" : "favorites-category-type-not-selected"}`}
            onClick={() => this.setState({searchType: "creations"}, () => browserHistory.push(homePathGenerator("favoritos/creaciones")))}
          >
            <p className={"favorites-category-type"}>{localization.get("favorites.creations")}</p>
          </div>
        </div>

        <Router {...this.props}>
          <Switch>
            <Route path={parseRouting("favoritos/creaciones")} render={wrap(this.FavoritesContentCreation)}/>
            <Route path={parseRouting("favoritos/creadores")} render={wrap(this.FavoritesContentCreator)}/>
            <Route path={parseRouting("favoritos")} render={() => <Redirect to={(localStorage.getItem("lastFavorited")) === "creation" ? "/favoritos/creaciones" : "/favoritos/creadores"}/>}/>
          </Switch>
        </Router>
      </div>
    )}
}

const wrap = (Comp) => props => {
  return <Comp {...props}/>
}

export default Favorites;